import {
  Administrator,
  AdministratorServiceClient,
  ChangePasswordRequest,
  ListAccountAccessRequest,
  UpdateUserOtpAuthRequest,
  DeleteAdministratorRequest,
  ListAdministratorRequest,
  CreateCorrespondentAccessRequest,
  ListCorrespondentAccessRequest,
  Access,
  DeleteAccessRequest,
  EmptyRequest,
  ForgotPasswordCheckEmailRequest,
  ForgotPasswordRequest,
  UpdateUserSettingsRequest,
  LazyUsersRequest,
} from '../proto/usrpb/administrator_grpc_web_pb';
import { Empty } from '../google/protobuf/empty_pb';
import { auth } from '../lib/auth/Auth';
import authSvc from './AuthService';
import { notifyError } from '../components/Messages/Notification';

import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new AdministratorServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });
const serviceNoAuth = new AdministratorServiceClient(window.env.GRPC_ENDPOINT);

const roleId = authSvc.getCurrentUser()?.RoleId;

const requestParameter = (param) => {
  let req = new Administrator();
  req.setUsrId(param.usrId);
  req.setEmail(param.email);
  req.setName(param.name.replace('  ', ' '));
  req.setPassword(param.password);
  req.setDefaultAccess(param.defaultAccess);
  req.setMobileNo(param.mobileNo);
  req.setUserType(param.userType);
  req.setStatus(param.status);
  req.setAdmin(param.admin);
  req.setAuthenticationMode(param.authenticationMode);
  req.setAccountId(param.accountId);
  req.setRoleId(param.roleId);
  req.setCorrespondent(param.correspondent);
  req.setAccountNo(param.accountNo);

  return req;
};

export async function createAdministrator(param) {
  return new Promise((resolve, reject) => {
    const req = requestParameter(param);

    service.createAdministrator(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateAdministrator(param) {
  return new Promise((resolve, reject) => {
    const req = requestParameter(param);

    service.updateAdministrator(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function changePassword(param) {
  return new Promise((resolve, reject) => {
    const req = new ChangePasswordRequest();
    req.setOldPassword(param.oldPassword);
    req.setNewPassword(param.newPassword);

    service.changePassword(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateUserOtpAuth(code) {
  return new Promise((resolve, reject) => {
    const req = new UpdateUserOtpAuthRequest();
    req.setValidationCode(code);

    service.updateUserOtpAuth(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function getUserOtpAuthUrl(param) {
  return new Promise((resolve, reject) => {
    service.getUserOtpAuthUrl(new Empty(), {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function acceptClientNotice() {
  return new Promise((resolve, reject) => {
    let req = new Empty();

    service.acceptClientNotice(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function deleteAdministrator(id) {
  return new Promise((resolve, reject) => {
    const req = new DeleteAdministratorRequest();
    req.setUserId(id);
    service.deleteAdministrator(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listAdministrator(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListAdministratorRequest();
    req.setEmail(param.email);
    req.setName(param.name);
    req.setUserType(param.userType);
    req.setStatus(param.status);
    req.setRoleId(param.roleId);
    req.setUserRoleId(roleId);
    req.setIsPendingClients(param.isPendingClients);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listAdministrator(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

const accessParameter = (param) => {
  let req = new Access();
  req.setUsrId(param.usrId);
  req.setRoleId(param.roleId);
  req.setAccessId(param.accessId);
  req.setAccess(param.access);
  req.setSubAccess(param.subAccess);

  return req;
};

export async function createAccess(param) {
  return new Promise((resolve, reject) => {
    const req = accessParameter(param);
    service.createAccess(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function deleteAccess(param) {
  return new Promise((resolve, reject) => {
    const req = new DeleteAccessRequest();
    req.setAccessId(param);
    service.deleteAccess(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createCorrespondentAccess(param) {
  return new Promise((resolve, reject) => {
    const req = new CreateCorrespondentAccessRequest();
    req.setUsrId(param.usrId);
    req.setCorrespondent(param.correspondent);
    service.createCorrespondentAccess(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listAccess(param) {
  return new Promise((resolve, reject) => {
    const req = accessParameter(param);
    service.listAccess(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listCorrespondentAccess(usrId) {
  return new Promise((resolve, reject) => {
    const req = new ListCorrespondentAccessRequest();
    req.setUsrId(usrId);
    service.listCorrespondentAccess(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listDefaultAccessOption() {
  return new Promise((resolve, reject) => {
    service.listDefaultAccessOption(new EmptyRequest(), {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function forgotPasswordCheckEmail(email, correspondent) {
  return new Promise((resolve, reject) => {
    const req = new ForgotPasswordCheckEmailRequest();
    req.setEmail(email);
    req.setCorrespondent(correspondent);

    serviceNoAuth.forgotPasswordCheckEmail(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function forgotPassword(param) {
  return new Promise((resolve, reject) => {
    const req = new ForgotPasswordRequest();
    req.setExternalAuthId(param.externalAuthId);
    req.setCode(param.code);
    req.setEmail(param.email);
    req.setNewPassword(param.newPassword);
    req.setSecurityAnswer(param.securityAnswer);
    req.setCorrespondent(param.correspondent);

    serviceNoAuth.forgotPassword(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listAccountAccess({ usrId }) {
  return new Promise((resolve, reject) => {
    const req = new ListAccountAccessRequest();
    req.setUsrId(usrId);

    service.listAccountAccess(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateUserSettings(param) {
  return new Promise((resolve, reject) => {
    const req = new UpdateUserSettingsRequest();
    req.setMobileNo(param.mobileNo);
    req.setAuthenticationMode(param.authenticationMode);
    service.updateUserSettings(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function removeUserOtpAuth() {
  return new Promise((resolve, reject) => {
    service.removeUserOtpAuth(new EmptyRequest(), {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function lazyUsers(key) {
  return new Promise((resolve, reject) => {
    const req = new LazyUsersRequest();
    req.setKey(key);

    service.lazyUsers(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function currentUserDetails() {
  return new Promise((resolve, reject) => {
    service.currentUserDetails(new Empty(), {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
